/**
 * The Lab's `?preset=name` (ui/labPresets.ts): on load, before anything reads the page's URL, the address is rewritten
 * to the preset's launch query (other parameters given beside it kept), so every reader — the launch (autoplay.ts),
 * the presentation flags — sees one query. Imported first by the entry point and by autoplay.ts, whose parameters are
 * read when it loads. An unknown preset leaves the address alone.
 */
import { expandPreset } from '../ui/labPresets';

if (typeof location !== 'undefined' && typeof history !== 'undefined') {
  const q = expandPreset(location.search);
  if (q !== null) history.replaceState(history.state, '', location.pathname + q + location.hash);
}

export {};
